import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { registrationPage1Request, registrationPage1Success, registrationPage1Failure } from '../reducers/login';
import { xapiRequest } from '../reducers/xapi';
import { API_LINK } from '../../constants';
import * as moment from 'moment';
const API = `${API_LINK}api/registerPage2`;

function* registrationPage1FunctionAxios() {
 
  const state = yield select(fullState => fullState);
  
  const {
    email,
    password,
    firstname,
    lastname,
    programCode,
    telephone,
    birthdate,
    gender,
    employeeNo,
    race,
    language,
    identityNo,
    conTitleID,
    maidenName,
    disability,
    conSocioEconomicStatus,
    conCountryID,
    conRegion,
    conBranch,
    conProvinceID,
    positionHeld,
    highestQualification,
    highestSchoolLevel,
    cell,
    socc,
    address,
    city,
    code,
    businessUnit,
    noYears,
  } = state.form.registration.values;
  
  const amLeader =  0;
  const dob = moment(state.form.registration.values.birthdate).format('YYYY-MM-DD')
  const { userId } = state.loginReducer.user;
  var countryId = conCountryID;
  if( Array.isArray(countryId)){
    countryId= conCountryID[0];
  }
  var regionId = conRegion;
  if( Array.isArray(regionId)){
    regionId= conRegion[0];
  }
  var branchId = conBranch;
  if( Array.isArray(branchId)){
    branchId= conBranch[0];
  }
  const response = yield call(() => {
    return axios({
      method: 'post',
      url: API+'/'+userId,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      data: {
        conCountryID: countryId,
        conClientRegionID: regionId,
        conClientBranchID: branchId,
        employeeNo: employeeNo !== null ? employeeNo : '',
        businessUnit: businessUnit !== null ? businessUnit : '',
        positionHeld: positionHeld !== null ? positionHeld : '',
      },
    });
  });
  
  return response;
}

function* workerRegistrationPage1Saga() {
  try {
    const response = yield call(registrationPage1FunctionAxios);
    const responseFromLogin = response.data;

    if (response.status === 200) {
      yield put(registrationPage1Success(responseFromLogin));
      yield put(xapiRequest({ xapiType: 'Registration 1' }));
    }

    if (response.status === 205) {
      
      yield put(registrationPage1Failure('Email does not exist'));
    }
    if (response.status === 206) {
      
      yield put(registrationPage1Failure(response.data));
    }
    if (response.status === 208) {
      
      yield put(registrationPage1Failure(response.data));
    }
    if (response.status === 500) {
      
      yield put(registrationPage1Failure(response.statusText));
    }
  } catch (error) {
    
    yield put(registrationPage1Failure(error));
  }
}

export function* watcherRegistrationPage1Saga() {
  yield takeLatest(registrationPage1Request().type, workerRegistrationPage1Saga);
}
